import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { useBffClient } from 'src/app/hooks/data/useBffClient';
import type { Lead } from 'src/app/types/lead';

interface CreateLead {
  email: string;
  zipCode: string;
  source: string;
}

export const useCreateLead = (): UseMutationResult<Lead, AxiosError, CreateLead> => {
  const authClient = useBffClient();

  return useMutation(
    (input: CreateLead) =>
      authClient
        .post(`lead/`, { email: input.email, source: input.source, zip_code: input.zipCode })
        .then((resp: { data: Lead }) => resp.data),
    {}
  );
};
